var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resizable-block',{staticClass:"nav-wrapper",attrs:{"type":"sidebarWidth","resizeWidth":true,"defaultWidth":250}},[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"ctaButton"},[_vm._t("ctaButton")],2),_c('div',{ref:"scrollableEl",staticClass:"scrollable"},[_vm._t("main")],2)]),_vm._t("showHidden")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }